import axiosRequest from '../axios-config';

export const getBranches = async () => {
  const config = {
    method: 'get',
    url: `/mstore/store-locator`,
  };
  try {
    const res = await axiosRequest(config);
    return res.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBranchesV2 = async (locale = 'ar') => {
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/store-locator/${locale}`,
  };
  try {
    const res = await axiosRequest(config);
    return res.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getBranchesNearMe = async (data) => {
  const config = {
    method: 'POST',
    url: `/branch/near-me`,
    data: JSON.stringify({ location: data }),
  };
  try {
    const res = await axiosRequest(config);
    return res.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
